<script>
import {nextTick} from 'vue';

export default {
    props: {
        currentStartProduct: [Object],
        currentProducts: [],
        currentShowStartButton: false
    },

    data() {
        return {
            dataLayer: null,
            container: null,
            currentStep: null,
            activeStep: 1,
            totalSteps: 1,
            startProduct: null,
            selectedProduct: null,
            products: [],
            configuration: {},
            showStartButton: false
        }
    },

    mounted() {
        this.dataLayer = window.dataLayer || [];
        this.startProduct = this.currentStartProduct;
        this.showStartButton = this.currentShowStartButton;
        this.products = this.currentProducts;
        this.container = document.querySelector('.js-vue-calculator');
        this.currentStep = this.$refs.progress.querySelector('.step');

        this.$nextTick(() => {
            if (!this.showStartButton) {
                this.container.querySelector('.calculator-container').classList.add('is-loaded');
                this.container.querySelector('input[type="radio"]').click();
            }

            this.calculateScrollPosition();
            this.totalSteps = this.getTotalSteps();
        });
    },

    created() {
        // ...
    },

    watch: {
        configuration: {
            handler(newValue, oldValue) {
                this.$nextTick(() => {
                    this.totalSteps = this.getTotalSteps();
                    this.selectedProduct = this.getProductByFilter(newValue);

                    if (!this.selectedProduct) {
                        this.selectedProduct = this.startProduct;
                    }
                });
            },
            deep: true
        },

        activeStep: function (val) {
            this.container.scrollIntoView();
            let currentStep = val - 1;
            this.currentStep = this.getStepByIndex(currentStep);
            document.querySelector('#calculator-summary').dataset.module = 'Step ' + currentStep;
        }
    },

    methods: {
        /*
        parseFilter() {
            let activeStep = this.activeStep;

            for (const [key, value] of Object.entries(this.$refs)) {
                if (key.includes('filter-') && parseInt(value.dataset.step) === activeStep) {
                    let filterKey = key.replace(/filter-/g, '');
                    if (typeof this.configuration[filterKey] === "undefined") {
                        let element = value.querySelector('input[name="' + filterKey + '"][value="' + this.selectedProduct[filterKey] + '"]');
                        if (element) {
                            element.click();
                        }
                    }
                }
            }
        },
         */

        show() {
          if (this.showStartButton)  {
              this.showStartButton = false;

              this.$nextTick(() => {
                  this.container.querySelector('.calculator-container').classList.add('is-loaded');
                  this.container.querySelector('input[type="radio"]').click();
                  this.container.scrollIntoView();
              });
          }
        },

        isValidStep(currentStep) {
            let selector = 'input[type="radio"]:checked';

            if (this.$refs['step-' + currentStep]) {
                return this.$refs['step-' + currentStep].querySelectorAll(selector).length > 0;
            } else {
                return false;
            }
        },

        matchFilterValue(filter, value) {
            if (typeof this.configuration[filter] === "undefined") {
                return false;
            }

            return this.configuration[filter] === value;
        },

        getProductByFilter(configuration) {
            const filter = Object.entries(configuration);
            return this.products.filter(product => {
                for (let [key, value] of filter) {
                    if (typeof product[key] !== "undefined") {
                        if (value === 'true') {
                            value = true;
                        }

                        if (value === 'false') {
                            value = false;
                        }

                        if (product[key] !== value) {
                            return false;
                        }
                    }
                }

                return true;
            })[0];
        },

        checkFilterCondition(conditionFilter, conditionValue) {
            if (conditionValue !== '' && this.configuration[conditionFilter] !== conditionValue) {
                return false;
            }

            return true;
        },

        checkProductCondition(conditionFilter, conditionValue) {
            if (conditionValue === 'true') {
                conditionValue = true;
            }

            if (conditionValue === 'false') {
                conditionValue = false;
            }

            if (conditionValue !== '' && this.selectedProduct !== null && typeof this.selectedProduct[conditionFilter] !== "undefined" && this.selectedProduct[conditionFilter] !== conditionValue) {
                return false;
            }

            return true;
        },

        compareFilterCondition(field, conditionFilter, conditionValue) {
            if (conditionValue !== '' && this.configuration[conditionFilter] !== conditionValue) {
                delete this.configuration[field];
                return false;
            }

            return true;
        },

        isParentVisible(field, conditionFilter, conditionValue) {
            if (!this.checkFilterCondition(conditionFilter, conditionValue)) {
                delete this.configuration[field];
                return false;
            }

            return true;
        },

        getStepByIndex: function (index) {
            let steps = [...this.$refs.progress.querySelectorAll('.step')];

            return steps[index];
        },

        getTotalSteps: function () {
            return [...this.$refs.progress.querySelectorAll('.step')].length;
        },

        scrollToStep: function (event, step) {
            let currentStep = this.activeStep;

            if (step < currentStep || this.isValidStep(currentStep)) {
                let target = event.target;
                let clickText = target.dataset.eventClicktext;

                if (step > currentStep) {
                    clickText = JSON.stringify(this.configuration);
                }

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'nfx_event',
                    event_section: target.closest('section').getAttribute('id'),
                    event_modul: 'Calculator > Step ' + currentStep,
                    event_element: 'textlink',
                    event_thema: target.closest('[data-event-topic]').dataset.eventTopic,
                    event_klicktext: clickText,
                    event_target: target.href,
                });

                this.$nextTick(() => {
                    this.activeStep = step;
                });
            }
        },

        calculateScrollPosition() {
            const rect = this.$refs.summary.getBoundingClientRect();

            if ((rect.y + rect.height) < 0) {
                this.$refs.price.classList.add('is-visible')
            } else {
                this.$refs.price.classList.remove('is-visible')
            }

            requestAnimationFrame(this.calculateScrollPosition.bind(this));
        }
    },

    computed: {},

    components: {}
};
</script>
